export default "__VITE_ASSET__C66X3G45__"